export const {
  API_URL,
  DOCHUB_API_URL,
  DOCHUB_FRONT_URL,
  PUSHER_WS_HOST,
  PUSHER_WSS_PORT,
  PUSHER_KEY,
  PUSHER_AUTH_ENDPOINT,
  SENTRY_DSN,
  URL_VERSION_CHAT,
} = window;
